import React, { useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import LineChartReact from "../../components-react/LineChartReact";
import { formatDateTimezon, formattedAmount } from "../../common-data/Converts";
import FixedLayoutTable from "../../common-components/FixedLayoutTable";
import TabViewPTRevDetail from "./common/TabViewPTRevDetail";

const PTRevenue = ({ allChartsData, gymQP }) => {
  const { todaysTotal, total, allData, fullTotal, partial } =
    allChartsData || {};

  const regex = /gym_id=([^&]*)/;
  const match = gymQP.match(regex);
  const gymId = match ? match[1] : "";

  const iniModVal = {
    date: "",
    detailModal: false,
  };
  const [modValues, setModValues] = useState(iniModVal);

  function formatMonth(dateString) {
    const parts = dateString.split("T");

    return parts[0];
  }

  const chartData =
    allData &&
    allData?.map((item) => ({
      month:
        item?.month?.trim() ||
        (item?.truncated_date &&
          moment(item?.truncated_date).tz("Asia/Kolkata").format("DD-MM-YYYY")),
      total_price: parseFloat(item?.total_price) || 0,
    }));

  const chartOpt = {
    series: [
      {
        name: "series1",
        data: chartData?.map((item) => item.total_price),
      },
    ],
    options: {
      colors: ["#f13434"],
      chart: {
        type: "area",
        fontFamily: "DM Sans",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      xaxis: {
        categories: chartData?.map((item) =>
          item?.month ? formatMonth(item.month) : ""
        ),
        // categories: chartData?.map((item) => item.month),
      },
      yaxis: {
        opposite: false,
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          let label = "N/A";
          if (w?.globals?.categoryLabels[dataPointIndex]) {
            label = w?.globals?.categoryLabels[dataPointIndex];
          }
          return (
            '<div className="bg-black text-white p-1">' +
            "<span>" +
            label +
            " / ₹" +
            series[seriesIndex][dataPointIndex] +
            " " +
            "</span>" +
            "</div>"
          );
        },
      },
    },
  };

  const onCloseModal = () => {
    setModValues(iniModVal);
  };

  const onClickDate = (date) => {
    setModValues((prevs) => ({
      ...prevs,
      date: formatDateTimezon(date),
      detailModal: true,
    }));
  };

  const tbCols = ["Date", "Amount"];

  return (
    <>
      <Modal
        isOpen={modValues.detailModal}
        onRequestClose={onCloseModal}
        contentLabel="Revenue Detail Modal"
        ariaHideApp={false}
      >
        <TabViewPTRevDetail
          prevData={modValues.date}
          prevGymId={gymId}
          onCloseModal={onCloseModal}
        />
      </Modal>

      <div className={`erpCard tepl ptRevenue`}>
        <div className="settlementGraphContainer">
          <div className="settleGraphTitleAndFilter">
            <h5 className="tite">PT Revenue</h5>

            <div className="lastFlex">
              <div className="todaysOverallRevenue">
                <button className="todayOveralll toady">
                  <span>Today’s</span>
                  <span>₹{formattedAmount(todaysTotal || 0)}</span>
                </button>
                <button className="todayOveralll overall">
                  <span>Overall </span>
                  <span>₹{formattedAmount(total || 0)}</span>
                </button>
                <button className="todayOveralll fullPartial">
                  <span>Partial/Full </span>
                  <span>
                    ₹{formattedAmount(parseInt(partial || 0))} /{" "}
                    {formattedAmount(parseInt(fullTotal || 0))}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div className="settleGraphBody">
            <div className="graphedCard">
              <LineChartReact chartOpt={chartOpt} />
            </div>
          </div>
        </div>
      </div>

      <div className="mt30">
        <FixedLayoutTable
          name={"pt_revenue"}
          tbCols={tbCols}
          tbColumns={allData}
          onClickData={onClickDate}
        />
      </div>
    </>
  );
};

export default PTRevenue;
